import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
const _hoisted_2 = {
  class: "max-h-screen h-screen font-default touch-manipulation"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("fallback");
import ActionScreenContainer from "@/modules/action-screens/components/ActionScreenContainer.vue";
import Dialog from "@/modules/vue/components/Dialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const themeOverrides = ref({
      common: {
        heightSmall: '32px',
        heightMedium: '48px',
        heightLarge: '64px',
        fontSizeSmall: '1rem',
        fontSizeMedium: '1.25rem',
        fontSizeLarge: '2rem'
      },
      Button: {
        paddingLarge: '2rem',
        paddingMedium: '1.25rem'
      },
      Checkbox: {
        sizeLarge: '2.5rem',
        sizeMedium: '2rem',
        sizeSmall: '1.5rem'
      },
      Drawer: {
        bodyPadding: '1rem',
        headerPadding: '1rem'
      },
      Message: {
        fontSize: '1rem',
        padding: '20px',
        margin: '1rem'
      },
      Rate: {
        itemColorActive: '#ee0a24'
      },
      Switch: {
        buttonHeightLarge: '38px',
        buttonWidthLarge: '38px',
        buttonWidthPressedLarge: '44px',
        railHeightLarge: '42px',
        railWidthLarge: '60px'
      },
      Spin: {
        sizeLarge: '10rem'
      }
    });
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      const _component_NConfigProvider = _resolveComponent("NConfigProvider");
      const _component_NDialogProvider = _resolveComponent("NDialogProvider");
      const _component_NMessageProvider = _resolveComponent("NMessageProvider");
      return _openBlock(), _createBlock(_Suspense, null, {
        fallback: _withCtx(() => [_hoisted_3]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NMessageProvider, {
          to: "#layout-body",
          duration: 3000,
          placement: "bottom-right"
        }, {
          default: _withCtx(() => [_createVNode(_component_NDialogProvider, null, {
            default: _withCtx(() => [_createVNode(_component_NConfigProvider, {
              "theme-overrides": themeOverrides.value
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(Dialog), _createVNode(ActionScreenContainer), _createVNode(_component_RouterView)])]),
              _: 1
            }, 8, ["theme-overrides"])]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});